<template>
  <div class="opera-revenueCompare" @click.self="showRevenueState = false">
    <topNav :title="$t('revenueCompare_title')"></topNav>
    <div class="topNav clearfix topDis">
      <div class="topNav_content">

        <ul class="nav reveune" @click="selectList('showRevenueState')" :class='{show:showRevenueState}'>
          <li class="selected"><i class="iconfont icon-paixu"></i>{{items[selected].dis}}</li>
          <template v-for="(item,key) in items">
            <li v-if="key < items.length-1" class="list" @click="selectState($event,key)"
                :class='{active:selected==key}'>{{item.dis}}
            </li>


            <li v-else class="list last" @click="selectState($event,key)" :class='{active:selected==key}'>{{item.dis}}
            </li>


          </template>
          <i class="iconfont icon-xia " key='100'></i>
        </ul>
      </div>
    </div>

    <div id="chart">

    </div>
    <div class="chartform">
      <table>
        <tr>
          <th>{{$t('revenueCompare_month')}}</th>
          <th>{{thisYear-1}}</th>
          <th>{{thisYear}}</th>
          <th>{{$t('revenueCompare_sequential')}}</th>
          <th>{{$t('revenueCompare_compared')}}</th>
        </tr>
        <tr v-for="(item,key) in reportInfo" :class='{gray:key%2==0}'>
          <td>{{item.month}}</td>
          <td v-html="formatkW(item.lamount)"></td>
          <td v-html="formatkW(item.amount1)"></td>
          <td>
            {{item | divide('huan')}}
            <i class="iconfont icon-shangsheng" v-if='item.amount2 > 0 && +item.diff2>0'></i>
            <i class="iconfont icon-xiajiang" v-else-if='item.amount2 > 0 && +item.diff2<0'></i>
          </td>
          <td>
            {{item | divide('tong')}}
            <i class="iconfont icon-shangsheng" v-if='item.lamount > 0 && +item.diff>0'></i>
            <i class="iconfont icon-xiajiang" v-else-if='item.lamount > 0 && item.amount1 > 0 && +item.diff<0'></i>
          </td>
        </tr>
      </table>
    </div>
    <search :showFlag='showFlag' v-on:searchResult='getsearch' v-on:changeFlag="showFlag='none'"></search>
  </div>
</template>
<script>
  import search from "../operaCommon/search";
  import moment from "moment";
  // import myDatepicker from 'vue-datepicker/vue-datepicker-es6'
  import topDate from "../operaCommon/topDatePick";
  import json from "../../conf/datePick.js";
  import echarts from "echarts";
  import _ from "lodash";

  export default {
    data() {
      return {
        defaultDate: moment()
          .add("d", -1)
          .format("YYYY-MM-DD"),
        forward: true,
        hotel: {},
        option: json,
        Report: {
          code: "", //酒店范围代码（空时取当前）
          d: null, //日期（空时当前营业日）
          indexType: "TOTAL_REVENUE", //	指标类型（不可空）
          level: "", //酒店范围代码（可空）
          name: "" //i酒店范围的名称
        },
        reportInfo: {},
        items: [
          {key: "TOTAL_REVENUE", dis: this.$t("revenueCompare_rev_ttl")},
          {key: "ROOM_REVENUE", dis: this.$t("revenueCompare_rev_rm")},
          {key: "FOOD_BEV_REVENUE", dis: this.$t("revenueCompare_rev_fb")},
          {key: "OTHER_REVENUE", dis: this.$t("revenueCompare_rev_ot")},
          {key: "ADR_ROOM_WO_CH", dis: this.$t("revenueCompare_rm_avg")},
          {key: "revpar", dis: "REVPAR"},
          {key: "OCC_PERC", dis: this.$t("revenueCompare_rm_occ")}
        ],
        showRevenueState: false,
        showHotelList: false,
        dis: "k",
        oldYear: [],
        nowYear: [],
        selected: 0,
        showFlag: "none"
      };
    },
    mounted() {
      this.getRevenue();
    },
    methods: {
      dateChange(time) {
        console.log(time);
        this.Report.d = time;
        this.getRevenue();
      },
      getsearch(item) {
        // console.log(item)
        this.hotel = item;
        this.Report.code = item.code;
        this.Report.level = item.level;
        this.Report.name = item.descript;
        this.showFlag = "none";
        this.getRevenue();
      },
      selectList(item) {
        this[item] = ~this[item];
      },
      selectState(event, key) {
        event.cancelBubble = true;
        this.showRevenueState = false;
        this.selected = key;
        this.Report.indexType = this.items[this.selected].key;
        // console.log(this.items[this.selected].key);
        this.getRevenue();
      },
      drawChart() {
        var cData = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
        // data =data.slice (0,this.reportInfo.length)
        var echartFs = lib.flexible.rem2px([0.3]);
        var myChart = echarts.init(document.getElementById("chart", "customed"));
        var that = this;
        var option = {
          // color:['#e7737e','#8a98b5','#03c9cc','#ba9fe2','#2fb3f4','#ffb576'],
          title: {
            text: ""
          },
          legend: {
            data: [this.$t("thisYear"), this.$t("lastYear")]
          },
          grid: {left: "3%", right: "4%", bottom: "3%", containLabel: true},
          tooltip: {
            trigger: "axis",
            formatter: function (params) {
              var res = "<div><p>" + params[0].name + "月</p></div>";
              for (var i = 0; i < params.length; i++) {
                res +=
                  '<p><span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background-color:' +
                  params[i].color +
                  ';"></span>' +
                  params[i].seriesName +
                  ":<small>￥</small>" +
                  that.formatkW(params[i].data) +
                  "</p>";
              }
              return res;
            }
          },
          dataZoom: [
            {type: "inside"},
            {
              handleIcon:
                "M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z",
              handleSize: "80%",
              handleStyle: {
                color: "#fff",
                shadowBlur: 3,
                shadowColor: "rgba(0, 0, 0, 0.6)",
                shadowOffsetX: 2,
                shadowOffsetY: 2
              }
            }
          ],
          xAxis: {
            type: "category",
            data: cData
          },
          yAxis: {
            type: "value",
            axisTick: {inside: true},
            axisLabel: {
              inside: true,
              formatter: function (value, index) {
                if (value >= 100000000) return value / 100000000 + "亿";
                if (value >= 10000) return value / 10000 + "万";
                return value;
              }
            }
          },

          series: [
            {
              name: this.$t('thisYear'),
              type: "line",
              data: this.nowYear,
              smooth: true,
              symbol: "circle",
              symbolSize: 5,
              lineStyle: {normal: {width: 1}},
              itemStyle: {
                normal: {
                  label: {
                    textStyle: {
                      fontSize: echartFs
                    }
                  }
                }
              },
              areaStyle: {
                normal: {
                  color: new echarts.graphic.LinearGradient(
                    0,
                    0,
                    0,
                    1,
                    [
                      {
                        offset: 0,
                        color: "rgba(137, 189, 27, 0.3)"
                      },
                      {
                        offset: 0.8,
                        color: "rgba(137, 189, 27, 0)"
                      }
                    ],
                    false
                  ),
                  shadowColor: "rgba(0, 0, 0, 0.1)",
                  shadowBlur: 10
                }
              }
            },
            {
              name: this.$t('lastYear'),
              type: "line",
              data: this.oldYear,
              smooth: true,
              symbol: "circle",
              symbolSize: 5,
              lineStyle: {normal: {width: 1}},
              areaStyle: {
                normal: {
                  color: new echarts.graphic.LinearGradient(
                    0,
                    0,
                    0,
                    1,
                    [
                      {
                        offset: 0,
                        color: "rgba(0, 136, 212, 0.3)"
                      },
                      {
                        offset: 0.8,
                        color: "rgba(0, 136, 212, 0)"
                      }
                    ],
                    false
                  ),
                  shadowColor: "rgba(0, 0, 0, 0.1)",
                  shadowBlur: 10
                }
              },
              itemStyle: {
                normal: {
                  label: {
                    textStyle: {
                      fontSize: echartFs
                    }
                  }
                }
              }
            }
          ]
        };
        myChart.setOption(option);
      },
      /*获取营收对比*/
      getRevenue() {
        this.$http
          .post("/mobilepmsapi/opera/report/getReport1", this.Report)
          .then(res => {
            if (res.data.result == 0) {
              this.dis = 'w';//res.data.retVal.dis;
              this.reportInfo = res.data.retVal.data;
              this.hotel.descript = res.data.retVal.name;
              this.oldYear = [];
              this.nowYear = [];
              _.forEach(this.reportInfo, (el, index) => {
                this.oldYear.push(el.lamount);
                this.nowYear.push(el.amount1);
              });
              if (this.Report.d == null) {
                this.Report.d = res.data.retVal.search.d;
              }

              // console.log(res.data.retVal.search.d)
              this.drawChart();
            }
          });
      },
      desort(value) {
        var ret = [];
        for (var i = value.length - 1; i >= 0; i--) {
          ret.push(value[i]);
        }
        return ret;
      },
      formatkW(value) {
        if (this.dis == "k" && value >= 1000) {
          return (value / 1000).toFixed(2) + " <small>K</small>";
        } else if (this.dis == "w" && value >= 100000000) {
          return (value / 100000000).toFixed(2) + " <small>亿</small>";
        } else if (this.dis == "w" && value >= 10000) {
          return (value / 10000).toFixed(2) + " <small>万</small>";
        } else {
          return value;
        }
      }
    },
    filters: {
      divide(arg1, arg2) {
        if (arg2 == "huan") {
          return arg1.amount2 == 0
            ? "-"
            : (arg1.diff2 * 100 / arg1.amount2).toFixed(0) + "%";
        } else if (arg2 == "tong") {
          return arg1.lamount == 0 || arg1.amount1 == 0
            ? "-"
            : (arg1.diff * 100 / arg1.lamount).toFixed(0) + "%";
        }
      },
      toThousands(num) {
        return ("" + num).replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g, "$1,");
      }
    },
    computed: {
      thisYear() {
        var date = new Date();
        return date.getFullYear();
      }
    },
    components: {
      // "date-picker": myDatepicker,
      topDate: topDate,
      search
    }
  };
</script>
<style lang='less'>
  .opera-revenueCompare {
    height: auto;
    min-height: 100%;

    .topNav {
      /*z-index: 1000;*/
      height: 48px;
      background-color: #f6f8f9;
      width: 100%;
      box-sizing: border-box;
      padding: 0;
      padding-bottom: 5px;

      .topNav_content {
        width: 100%;
        height: 100%;
        background-color: #fff;
      }

      .nav {
        position: relative;
        height: 100%;
        float: left;
        z-index: 1;
        overflow: hidden;
        line-height: 48px;

        .icon-xia {
          position: absolute;
          top: 0;
          right: 0;
          line-height: 48px;
          color: #000;
          z-index: 1;
          font-size: 20px;
        }
      }

      .time {
        width: 35%;
        z-index: 20;
      }

      .hotel {
        float: left;

        .hotelInput {
          height: 25px;
          padding: 0 10px;
          text-align: center;
          width: ~"calc(100% - 16px)";
          box-sizing: border-box;
          border: none;
        }

        &.show {
          overflow: visible;

          .icon-xia {
            transform: rotate(180deg);
          }
        }
      }

      .reveune {
        width: 30%;
        float: right;

        i {
          font-size: 0.5rem;
          color: #999;
        }

        .selected {
          overflow: hidden;
          height: 100%;
          line-height: 43px;
          box-sizing: border-box;
          padding-right: 16px;
          text-align: center;
          padding-left: 10px;
          background-color: #fff;
        }

        .list {
          overflow: hidden;
          height: 36px;
          line-height: 36px;
          box-sizing: border-box;
          padding-right: 16px;
          text-align: center;
          padding-left: 10px;
          background-color: #fff;

          &.active {
            background-color: #eee;
            color: #f69c2d;
          }
        }

        .last {
          border-bottom: 1px solid #eee !important;
        }

        .icon-xia {
          right: 10px;
        }

        &.show {
          overflow: visible;

          li {
            //box-shadow:0px 0px 3px #333333;
            border: 1px solid #eee;
            border-top: none;
            border-bottom: none;
          }

          .icon-xia {
            transform: rotate(180deg);
          }
        }
      }
    }

    #chart {
      width: 100%;
      margin: 0 auto;
      padding: 0;
      height: 332px;
      box-sizing: border-box;
    }

    .chartform {
      width: 96%;
      margin: 0 auto;

      table {
        width: 100%;

        th {
          height: 38px;
          color: #fff;
          background-color: #f69c2d;
          width: 20%;
        }

        td {
          height: 41px;
          text-align: center;

          .icon-shangsheng {
            line-height: 41px;
            color: #ff485f;
          }

          .icon-xiajiang {
            line-height: 41px;
            color: #249f17;
          }
        }
      }
    }

    .flip-list-enter {
      background-color: red;
    }

    .gray {
      background-color: #f5f5f5;
    }
  }

  .revenueCompare .topNav .reveune.show li:last-child {
    background-color: red;
  }
</style>



// WEBPACK FOOTER //
// revenueCompare.vue?faa6b022